import { render, staticRenderFns } from "./GoodsInfoCell.vue?vue&type=template&id=4f543ad6&scoped=true"
import script from "./GoodsInfoCell.vue?vue&type=script&lang=js"
export * from "./GoodsInfoCell.vue?vue&type=script&lang=js"
import style0 from "./GoodsInfoCell.vue?vue&type=style&index=0&id=4f543ad6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f543ad6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f543ad6')) {
      api.createRecord('4f543ad6', component.options)
    } else {
      api.reload('4f543ad6', component.options)
    }
    module.hot.accept("./GoodsInfoCell.vue?vue&type=template&id=4f543ad6&scoped=true", function () {
      api.rerender('4f543ad6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketingFunction/superSubsidyV2/components/GoodsInfoCell.vue"
export default component.exports